import {
  toLocalStorage,
  validateOrResetLocalStorageOnIntroPage,
} from '@actions/formulary';
import { sourceOriginLead } from '@config/constants';
import { catalog } from '@core/catalog';
import { FC, type ReactNode, useState } from 'react';
import { FormContext, type FormData } from '.';

const initialFormData: FormData = {
  consentPartners: 'off',
  hasRequestedAdvice: 0,
  sourceOriginLead,
  sourceId: null,
  sourceName: null,
  professionalSituationName: null,
  domainName: null,
  formationId: null,
};

// Legacy cleanup of stale form keys left in existing browsers; no restore
// (form state lives in React state/context now, not localStorage).
validateOrResetLocalStorageOnIntroPage();

interface Props {
  children: ReactNode;
}

const MultiStepFormContextProvider: FC<Props> = ({ children }) => {
  const [formDataContext, setFormDataContext] = useState<FormData>(() => ({
    ...initialFormData,
    ...catalog().formQueryParams,
  }));

  const updateFormData = (newFormData: { name: string; value: unknown }) => {
    toLocalStorage({ [newFormData.name]: newFormData.value });
    setFormDataContext((prev) => ({
      ...prev,
      [newFormData.name]: newFormData.value,
    }));
  };

  return (
    <FormContext.Provider value={{ formDataContext, updateFormData }}>
      {children}
    </FormContext.Provider>
  );
};

export default MultiStepFormContextProvider;
